import { useId } from "react";

import { cn } from "@/lib/cn";

import type { Mood } from "./api";

/** The face on the bull's screen, as in the approved design. */
function Face({ mood }: { mood: Mood }) {
  if (mood === "happy")
    return (
      <>
        <path d="M42 68q8-11 16 0M70 68q8-11 16 0" stroke="#5dffa8" strokeWidth="5" fill="none" strokeLinecap="round" />
        <path d="M50 78q14 15 28 0z" fill="#5dffa8" />
      </>
    );
  if (mood === "sad")
    return (
      <>
        <circle cx="50" cy="66" r="6" fill="#ffb4a8" />
        <circle cx="78" cy="66" r="6" fill="#ffb4a8" />
        <path d="M54 87q10-8 20 0" stroke="#ffb4a8" strokeWidth="4" fill="none" strokeLinecap="round" />
      </>
    );
  return (
    <>
      <g className="ai-mascot-eyes">
        <circle cx="50" cy="66" r="7" fill="#7ef0ff" />
        <circle cx="78" cy="66" r="7" fill="#7ef0ff" />
      </g>
      <path d="M54 82q10 7 20 0" stroke="#7ef0ff" strokeWidth="4" fill="none" strokeLinecap="round" />
    </>
  );
}

/**
 * The bull robot: horns for the market, a screen for a face. Its own colours in both
 * themes, like the app's dark header. Moves only when motion is allowed (styles.css).
 */
export function Mascot({ mood = "watching", className }: { mood?: Mood; className?: string }) {
  const id = useId();
  return (
    <svg
      viewBox="0 0 128 128"
      aria-hidden
      data-mood={mood}
      className={cn(mood === "happy" && "ai-mascot-bounce", className)}
    >
      <defs>
        <linearGradient id={id} x1="0" y1="0" x2="1" y2="1">
          <stop offset="0" stopColor="#2f6bff" />
          <stop offset="1" stopColor="#5a3fd6" />
        </linearGradient>
      </defs>
      <path d="M28 40C14 34 10 18 16 8c6 12 16 18 28 20z" fill="#f0a71f" />
      <path d="M100 40c14-6 18-22 12-32-6 12-16 18-28 20z" fill="#f0a71f" />
      <rect x="22" y="28" width="84" height="80" rx="30" fill={`url(#${id})`} />
      <rect x="32" y="44" width="64" height="52" rx="18" fill="#0b1b45" />
      <Face mood={mood} />
      <rect x="58" y="108" width="12" height="10" rx="3" fill="#2f6bff" />
      <rect x="42" y="116" width="44" height="8" rx="4" fill="#0b1b45" />
    </svg>
  );
}
